export default __webpack_public_path__ + "static/media/Invest-reill-3.58c2440f.png";